module.exports = "<div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/js/directives/report/view.html
// module id = 1009
// module chunks = 0